import React from "react";

import "./custom-marker.styles.scss";

const CustomMarker = ({ text, image }) => {
  return (
    <div class="marker-container">
      <img src={image} alt="" />
      <div className="marker-content">
        <a href="#">{text}</a>
      </div>
    </div>
  );
};

export default CustomMarker;
